import { Component, OnInit } from '@angular/core';
import { DataExchangeService } from 'src/app/shared/services/data-exchange.service';
import { Season } from 'src/app/shared/types/Season';
import { CDSService } from 'src/app/shared/services/cds.service';

interface StationInfo {
    id: string;
    latitude: string;
    longitude: string;
    srcName: string,

    geoid: string;

    city: string;
    county?: string;
    state: string;

    lobs?: string;
}

@Component({
    selector: 'ngxg-current',
    templateUrl: './current.component.html',
    styleUrls: ['./current.component.scss']
})
export class CurrentComponent implements OnInit {

    public loading: Boolean = true;

    public season: Season;
    public stationInfo: StationInfo;

    public riskMap: Object = { 'L': 'Low', 'M': 'Moderate', 'H': 'High' };

    constructor(private cdsService: CDSService, private dataExchangeService: DataExchangeService) {

        this.dataExchangeService.getConfig().subscribe(config => {
            if (config !== null) {
                this.season = config.season;
                
                this.cdsService.getStationInfo(this.season.weatherStation.id).subscribe(stationInfo => {

                    this.stationInfo = {
                        id: stationInfo.id,
                        latitude: parseFloat(stationInfo.loc.lat).toFixed(3),
                        longitude: parseFloat(stationInfo.loc.lon).toFixed(3),

                        srcName: stationInfo.src.name,
                        geoid: stationInfo.loc.geoid._id,

                        city: stationInfo.loc.geoid.city.name,
                        // county: stationInfo.loc.geoid.county.name,
                        state: stationInfo.loc.geoid.state.abbr,

                        lobs: stationInfo.lobs.dtme
                    };

                    if(stationInfo.loc.geoid.county != null){
                        this.stationInfo.county = stationInfo.loc.geoid.county.name;
                    }
                });

                this.loading = false;

            }
        });

    }

    ngOnInit() {
    }

}
